import { RouteComponentProps } from "@reach/router";
import { FunctionComponent } from "react";

const KeyGeneratorPage: FunctionComponent<RouteComponentProps> = () => {
  return (
    <main className="content-layout">
      <h1 className="title vertical-margin spaced thin">Key Generator</h1>
      <p>Coming soon</p>
    </main>
  );
};

export default KeyGeneratorPage;
